<template>
  <v-form>
    <!-- 光熱費確認画面 -->
    <v-container>
      <v-card class="parkingSelect" false>
        <v-row>
          <v-col cols="4" class="headerTitle">
            <ryou-select
              class="bukens"
              :items="dynamicItems"
              :itemText="'building_name'"
              :label="'物件名'"
              :itemValue="'building_id'"
              v-model="selectBuild"
              :value="selectBuild"
            >
            </ryou-select>
          </v-col>
          <v-col cols="4" class="headerTitle">
            <ryou-select
              class="bukens"
              :items="energyItems"
              :itemText="'code_text'"
              :label="'エネルギー選択'"
              :itemValue="'code_value'"
              v-model="selectEnergy"
              :value="selectEnergy"
            >
            </ryou-select>
          </v-col>
          <v-col cols="2" class="headerTitle">
            <ryou-date-format
              ref="ryou_date_format"
              v-model="date"
              :value="date"
              :rules="monthRules"
              :label="'対象年月'"
              :format="'$1/$2'"
            >
            </ryou-date-format>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="risuto" outlined>
        <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
        <v-form
          ref="tableForm"
          v-model="tableForm"
          lazy-validation
          @submit.prevent
        >
          <ryou-table
            ref="ryouTable"
            :rowKey="rowKey"
            :headers="headers"
            :needSearch="true"
            :dummy="false"
            :url="url"
            :height="800"
            :businessKeys="businessKeys"
            :queryParams="queryParam"
            style="margin-top: 10px"
          >
            <v-row slot="filterContainer"> </v-row>
          </ryou-table>
        </v-form>
      </v-card>
    </v-container>
  </v-form>
</template>

<script>
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouTable from "@/components/table/RyouTable.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
export default {
  name: "SalaryEnergyData",
  mixins: [RyouTableMixins],
  components: {
    RyouSelect,
    RyouTable,
    RyouDateFormat,
  },
  mounted() {
    this.monthRules.push(this.GlobalRules.required);
  },
  data() {
    return {
      tableForm: true,
      rowKey: "rowIndex",
      selectBuild: "",
      selectEnergy: "",
      date: "",
      monthRules: [],
      dynamicItems: [],
      energyItems: [],
      businessKeys: ["room_id", "building_id", "energyClass"],
      headers: [
        {
          text: "部屋番号",
          class: "blue lighten-2 title",
          value: "room_id",
          align: "center",
          width: "9%",
          groupable: false,
        },
        {
          text: "ユーザ名",
          class: "blue lighten-2 title",
          value: "user_name",
          align: "center",
          width: "20%",
          groupable: false,
        },
        {
          text: "集計期間",
          class: "blue lighten-2 title",
          value: "date_str",
          align: "center",
          width: "20%",
          groupable: false,
        },
        {
          text: "使用量",
          class: "blue lighten-2 title",
          value: "now_use_amount",
          align: "center",
          width: "15%",
          sortable: true,
          groupable: false,
        },
        {
          text: "使用料金",
          class: "blue lighten-2 title",
          value: "now_use_pay",
          align: "center",
          width: "15%",
          sortable: true,
          groupable: false,
        },
      ],
      url: {
        list: "/energyData/get" + "/" + null + "/" + null + "/" + null,
      },
      height: 800,
    };
  },
  created() {
    this.initData();
  },
  watch: {
    selectBuild() {
      //if (this.initFlag) {
      //    this.callLoadData()
      //}
      this.callLoadData();
    },
    selectEnergy() {
      this.callLoadData();
    },
    date() {
      this.callLoadData();
    },
  },
  methods: {
    initData(callLoadData) {
      //eslint-disable-line
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/energyInput/buildingNameGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        //物件名取得
        if (data.success) {
          var mapDatas = data.result.map((item) => {
            item.building_id = String(item.building_id);
            return item;
          });
          this.dynamicItems = mapDatas;
          this.selectBuild = this.dynamicItems[0].building_id;
        }
      });
      this.getRequest(
        "/energyInput/energyClassGet",
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        //エネルギー区分取得
        if (data.success) {
          var mapDatas = data.result.map((item) => {
            item.code_value = String(item.code_value);
            return item;
          });
          // ガスを表示しないようにフィルタリング
          this.energyItems = mapDatas.filter((x)=> x.code_value != "1");
          this.selectEnergy = this.energyItems[0].code_value;
          //this.initFlag = true;
        }
      });
      const tmpdate = new Date();
      const month = ("0" + (tmpdate.getMonth() + 1)).slice(-2);
      this.date = tmpdate.getFullYear() + "-" + month;

      //this.getRequest("/energyInput/existRoomGet", null, this.$store.getters.getUserToken).then(data => {  //存在する部屋取得
      //    if (data.success) {
      //    this.roomItems = data.result;
      //  }
      //});

      //this.callLoadData();
    },

    callLoadData() {
      if (
        this.selectBuild != "" &&
        this.selectEnergy != "" &&
        this.date != ""
      ) {
        this.url.list =
          "/energyInput/energyDataGet" +
          "/" +
          this.selectBuild +
          "/" +
          this.selectEnergy +
          "/" +
          this.date;
        this.$refs.ryou_date_format.initViewDate(this.date);
        this.$refs.ryouTable.loadData();
      }
    },
  },
};
</script>

<style scoped>
.detail {
  padding-top: 20px;
}

.headerTitle {
  padding-bottom: 0px;
}

.headerbtn {
  padding: 0px 12px;
  margin-bottom: 30px;
}

.buken {
  width: 150px;
  height: 60px;
  padding-top: 2%;
}

.bukens {
  width: 300px;
  height: 80px;
}

.buken,
.bukens {
  float: left;
  box-sizing: border-box;
}
</style>
